module.exports = __webpack_public_path__ + "static/media/area.f75d8982.svg";